<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <div class="row mt-0 mb-3">
      <div class="col px-0 custom-form-main-label">
        {{ $store.translate('manage_tasks_for_shift')}}
      </div>
    </div>
    <div class="row mb-1" v-if="dataIsSortedBySelf == false">
      <div class="col-12 p-0">

        {{$t('data_already_sorted')}}


      </div>
    </div>
    <div class="row">

      <div class="col p-0">
        <div v-bind:id="'divdrag' +  procSch.id+'_'+procSch.Order" v-bind:draggable="{'true':allowSort == true}" ondragstart="drag(event)" ondragend="dragend(event)" ondrop="drop(event)" ondragover="allowDrop(event)" class="row m-0" v-for="procSch in procedures">
          <div class="col-11 pl-0">
            <h6 class="card-title" v-if="locationId == procSch.locationid">{{ procSch.name }}
              <span v-if="procSch.WeekRepeat > 0"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-rotate-cw3"></i></span>
              <span v-if="procSch.StartDateStr !='' && procSch.EndDateStr !=''"><i  style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-calendar"></i></span>
              <span v-if="procSch.Weekdays != null && procSch.Weekdays.indexOf(',') > -1"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-stack"></i></span>
            </h6>
            <h6 class="card-title" v-if="locationId != procSch.locationid">{{procSch.locationname}} > {{ procSch.name }}
              <span v-if="procSch.WeekRepeat > 0"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-rotate-cw3"></i></span>
              <span v-if="procSch.StartDateStr !='' && procSch.EndDateStr !=''"><i  style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-calendar"></i></span>
              <span v-if="procSch.Weekdays != null && procSch.Weekdays.indexOf(',') > -1"><i style="line-height:0.7rem;font-size:0.7rem;" class="ml-1 icon-stack"></i></span>
            </h6>
          </div>
          <div class="col-1 pull-right" style="right: 0px;">
            <div class="dropdown pull-right pr-2">
              <a href="#" class="list-icons-item caret-0 font-weight-bold" data-toggle="dropdown">
                ...
              </a>
              <div class="skinnedmenu dropdown-menu dropdown-menu-right">
                <a @click="removeProcdure(procSch.id)" href="javascript: return false;" class="dropdown-item">{{$t('remove')}}</a>
                <a @click="edit(procSch.id)" href="javascript: return false;" class="dropdown-item">{{$t('edit')}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col p-0">
        <form id="addProcActForm" name="addProcActForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
          <div class="col p-0 mt-3">
            <div class="custom-form-label">
              {{$t('template')}}
            </div>
          </div>
          <div class="col mt-1">
            <!--<procedure-and-category-and-tag-selector @event-change-procedure="onChange"></procedure-and-category-and-tag-selector>-->
            <category-and-tag-selector @event-change-procedure="onChange"></category-and-tag-selector>
          </div>
          <div class="col-12 mt-3">
            <div class="col">
              <div class="row" v-if="catOrTagProcedures!=null && catOrTagProcedures.length>0">
                <input-checkbox @input="setOverrideAll" v-bind:value="0" v-bind:id="'chk_selectallProc'"
                                v-bind:name="'chk_selectallProc'" v-bind:checked="isCheckedSelectAll"
                                v-bind:text="'Select All'" class="mt-1"></input-checkbox>
              </div>
              <div class="row" v-for="proc in catOrTagProcedures">
                <input-checkbox @input="setOverride" v-bind:value="proc.Id" v-bind:id="'chk_' +  proc.Id"
                                v-bind:name="'chk_' +  proc.Id" v-bind:checked="proc.IsChecked"
                                v-bind:text="proc.Name" class="mt-1"></input-checkbox>
              </div>
            </div>
          </div>
          <div class="col p-0 mt-3">
            <button type="submit" class="btn skin primary-button mt-1 " @click="attachToShift">{{$t('add')}}</button>
            <a class="btn btn-link skin primary-button mt-1 " @click="displayCreateProcedure()">{{$t('create')}}</a>
          </div>
        </form>

        <div class="row">
          <div class="col-12 mt-1" v-if="showCreateProcedure == true">
            {{$t('new_procedure')}}
          </div>
        </div>
        <div class="row">
          <div class="col-10 mt-1" v-if="showCreateProcedure == true">
            <input type="text" v-model="newName" class="form-control" />
          </div>
          <div class="col-2 mt-1" v-if="showCreateProcedure == true">
            <button type="submit" class="btn skin primary-button" @click="saveNewProcedure">{{$t('save')}}</button>
          </div>
        </div>


      </div>
    </div>
    <div class="row">
      <div class="col-12 p-0 mt-3">
        <div class="custom-form-label">
          {{$t('copy_tasks_to')}}:
        </div>
      </div>
      <div class="col-4 pl-0 mt-1">
        <select v-model="copyToDay" class="form-control" @change="loadShiftsOnDay($event)">
          <option disabled value="">{{$t('schedule_select_day')}}</option>
          <option value="1">{{$t('monday')}}</option>
          <option value="2">{{$t('tuesday')}}</option>
          <option value="3">{{$t('wednesday')}}</option>
          <option value="4">{{$t('thursday')}}</option>
          <option value="5">{{$t('friday')}}</option>
          <option value="6">{{$t('saturday')}}</option>
          <option value="0">{{$t('sunday')}}</option>
        </select>
      </div>
      <div class="col-4 pl-0 mt-1">
        <select v-model="copyToShift" class="form-control" @change="donothing($event)">
          <option disabled value="-1">{{$t('select_shift')}}</option>
          <option v-for="siteShift in shiftsOnDay" v-bind:value="siteShift.SiteShiftId">{{siteShift.Name}}</option>
        </select>
      </div>
      <div class="col-4 pl-0 mt-1">
        <button class="btn skin primary-button" @click="copyTasks()">{{$t('copy')}}</button>
      </div>
      <div class="col-12 p-0 mt-3">
        <div>
          {{message}}
        </div>
      </div>

    </div>

    <modal-empty ref="thisModal" size="modal-xs" v-bind:title="$t('add_scheduling')">
      <div style="max-height:calc(100vh - 270px);overflow-y:auto">
        <div class="m-0 p-0">
          <add-schedule-selector v-bind:shiftId="shiftId" @event-add-procedureSch="onSaveScheduling" openInPopup="true" ref="addScheduleSelector"></add-schedule-selector>
        </div>
      </div>
    </modal-empty>

    
  </div>
</template>

<script>
  //import ProcedureSelector from '../procedure/procedure-selector.vue'
  var isCheckedSelectAll = false;
  export default {    
    name: "manage-shift-procedures",
    components: {

    },
    props: {

    },
    data() {
      return {
        catOrTagProcedures: [],
        procedures: null,
        locationId: -1,
        dayId: -1,
        shiftId: -1,
        selectedId: '-1',
        copyToDay: "",
        shiftsOnDay: [],
        copyToShift: "",
        message: "",
        showCreateProcedure: false,
        newName: "",
        dataIsSortedBySelf: true,
        isCheckedSelectAll: false,
      };
    },
    methods: {
      onSaveScheduling() {
        this.$refs.thisModal.close();
      },
      edit(id) {

        this.$refs.addScheduleSelector.setId(id);
        this.$refs.addScheduleSelector.setShiftid(this.shiftId);
        this.$refs.addScheduleSelector.getProcedureSchedule(id);
        this.$refs.thisModal.open();
      },
      setOverrideAll(checked, val, value) {
        if (this.catOrTagProcedures != null && this.catOrTagProcedures != undefined && this.catOrTagProcedures.length > 0) {
          this.catOrTagProcedures.forEach((item, index) => {
            item.IsChecked = checked;
          });
        }
        this.$forceUpdate();
      },
      setOverride(checked, val, value) {        
        if (this.catOrTagProcedures != null && this.catOrTagProcedures != undefined && this.catOrTagProcedures.length > 0) {
          var item = this.catOrTagProcedures.find(n => n.Id == val);
          console.log(item);
          if (item != null) {
            item.IsChecked = checked;
            console.log(item);
          }

          this.isCheckedSelectAll = true;
          this.catOrTagProcedures.forEach((item, index) => {
            if (item.IsChecked === false) {
              this.isCheckedSelectAll = false;
            }
          });          
          this.$forceUpdate();
        }
      },
      async saveNewProcedure() {
        if (this.newName == "")
          return;
        //var data = JSON.stringify({ name: name, date: null, locationId: null, istask: false });
        try {
          var url = '/api/Procedure/AddProcedure?istask=false&name=' + this.newName;

          this.$http.post(url, null).then(async response => {
            this.newName = "";
            this.selectedId = response.data.Id;

            var thisContext = this;

            this.attachProcdureShiftNoValidation();
            setTimeout(function () {
              thisContext.loadShiftProcedures(thisContext.locationId, thisContext.dayId, thisContext.shiftId);
              //thisContext.$forceUpdate();
            }, 500)

          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      displayCreateProcedure() {
        this.showCreateProcedure = true;
      },
      donothing(e) {
        this.copyToShift = e.target.value;
        this.$forceUpdate();
      },
      async copyTasks() {
        try {
          var url = '/api/Procedure/CopyLocationShiftTasks?fromlocationid=' + this.locationId + '&fromDay=' + this.dayId + '&toDay=' + this.copyToDay + '&copytositeshiftid=' + this.copyToShift + '&copyfromsiteshiftid=' + this.shiftId;
          this.$http.get(url).then(async response => {
            this.message = this.$t('copied') + ": " + response.data;
            this.$forceUpdate();
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      async loadShiftsOnDay(e) {
        this.message = "";
        this.copyToShift = "";
        this.copyToDay = "";
        try {
          var tmpArray = [];
          this.copyToDay = e.target.value;
          var url = `/api/Admin/v1/Shifts/Location/Day/${this.locationId}/${this.copyToDay}`;
          this.$http.get(url).then(async response => {
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].IsAdded == true)
                tmpArray.push(response.data[i]);
            }
            this.shiftsOnDay = tmpArray;
            this.$forceUpdate();
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      onOrderChange(arraydragids, arraydropids) {
        if (!this.dataIsSortedBySelf) {
          return;
        }
        var dragId = arraydragids[0];
        var dragOrder = arraydragids[1];

        var dropId = arraydropids[0];
        var dropOrder = arraydropids[1];

        //console.log("dragId=" + dragId + "dropId=" + dropId);
        if (dragId !== '' && dropId !== '' && dragId !== undefined && dropId !== undefined
          && dragId !== dropId) {



          for (let i = 0; i < this.procedures.length; ++i) {

            if (this.procedures[i].id == dragId) {

              if (this.procedures[i].Order == dropOrder) {
                this.procedures[i].Order = dropOrder + 0.1;
              } else {
                this.procedures[i].Order = dropOrder;
              }


            }
          }

          this.procedures = this.procedures.sort((a, b) => (a.Order > b.Order ? 1 : -1));

          for (let i = 0; i < this.procedures.length; ++i) {
            this.procedures[i].Order = i;
          }

          this.procedures = this.procedures.sort((a, b) => (a.Order > b.Order ? 1 : -1));

          try {
            var url = '/api/Procedure/UpdateMultipleActivitiesOrder';
            this.$http.post(url, this.procedures).then(async response => {
              //this.loadShiftProcedures(this.locationId, this.dayId, this.shiftId);
            });
          } catch (err) {
            alert(err);
          }

          /*
          try {
            var url = '/api/Procedure/UpdateActivitiesOrderOnDrag?dragId=' + dragId
              + "&dragorder=" + dragOrder + "&dropId=" + dropId + "&droporder=" + dropOrder;
            this.$http.get(url).then(async response => {
              //this.loadShiftProcedures(this.locationId, this.dayId, this.shiftId);
            });
          } catch (err) {
            alert(err);
          }
          */
        }
      },
      onChange(type, id) {
        this.selectionType = type
        this.selectedId = id;

        if (this.selectionType !== undefined && (this.selectionType == "category" || this.selectionType == "tag")) {
          this.getProceduresByCategoryOrTag();
        } else {
          this.catOrTagProcedures = [];
          this.isCheckedSelectAll = false;
          this.$forceUpdate();
        }
      },
      getId() {
        return this._uid;
      },

      loadShiftProcedures(locId, day, shiftId) {
        this.message = "";
        this.copyToShift = "";
        this.copyToDay = "";
        try {
          this.locationId = locId;
          this.dayId = day;
          this.shiftId = shiftId;
          var url = '/api/Procedure/GetProcedureByShiftday?locationId=' + locId + '&day=' + day + '&siteShift=' + shiftId;
          this.$http.get(url).then(response => {
            this.procedures = response.data;
            this.$forceUpdate();
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      async removeProcdure(procId) {
        try {
          var url = '/api/Procedure/RemoveProcSchShift?procSchId=' + procId;
          this.$http.get(url).then(async response => {
            this.loadShiftProcedures(this.locationId, this.dayId, this.shiftId);
          });
        } catch (err) {
          alert(err);
        }
      },
      async attachProcdureShiftNoValidation() {
        try {
          var request = {
            locationId: this.locationId, day: this.dayId, procId: this.selectedId,
            shiftId: this.shiftId
          };
          var response = await this.$http.post(
            '/api/Procedures/v1/AddProcActvity',
            request
          ).then(async response => {
            this.loadShiftProcedures(this.locationId, this.dayId, this.shiftId);
          });
        } catch (err) {
          alert(err);
        }
      },

      async attachToShift() {

        if (this.selectionType == "procedure") {
          this.attachProcdureShift();
        }

        //if (this.selectionType == "category") {
        //  this.attachCategoryProceduresToShift();
        //}

        //if (this.selectionType == "tag") {
        //  this.attachTagProceduresToShift();
        //}
        if (this.selectionType == "category" || this.selectionType == "tag") {
          //this.getProceduresByCategoryOrTag();
          let ids = [];
          this.catOrTagProcedures.forEach((item, index) => {
            if (item.IsChecked) {
              ids.push(item.Id);
            }
          });
          if (ids.length > 0) {
            this.addProceduresWithActvities(ids)
          }
          console.log(ids);
        }

      },
      async addProceduresWithActvities(ids) {
        try {
          if (!$('#addProcActForm').valid())
            return false;
          var request = {
            locationId: this.locationId, day: this.dayId, procs: ids,
            shiftId: this.shiftId
          };
          var response = await this.$http.post(
            '/api/Procedure/AddProceduresWithActvities',
            request
          ).then(async response => {
            this.loadShiftProcedures(this.locationId, this.dayId, this.shiftId);
          });
        } catch (err) {
          alert(err);
        }
      },
      async getProceduresByCategoryOrTag() {
        try {
          var request = {
            type: this.selectionType, id: this.selectedId
          };
          var response = await this.$http.post(
            '/api/Procedure/GetProceduresByCategoryOrTag',
            request
          ).then(async response => {
            this.catOrTagProcedures = response.data;
            this.$forceUpdate();
          });
        } catch (err) {
          alert(err);
        }
      },


      async attachCategoryProceduresToShift() {
        try {
          if (!$('#addProcActForm').valid())
            return false;
          var request = {
            locationId: this.locationId, day: this.dayId, categoryId: this.selectedId,
            shiftId: this.shiftId
          };
          var response = await this.$http.post(
            '/api/Procedure/AddCategoryActvities',
            request
          ).then(async response => {
            this.loadShiftProcedures(this.locationId, this.dayId, this.shiftId);
          });
        } catch (err) {
          alert(err);
        }
      },

      async attachTagProceduresToShift() {
        try {
          if (!$('#addProcActForm').valid())
            return false;
          var request = {
            locationId: this.locationId, day: this.dayId, tag: this.selectedId,
            shiftId: this.shiftId
          };
          var response = await this.$http.post(
            '/api/Procedures/v1/AddTagActvities',
            request
          ).then(async response => {
            this.loadShiftProcedures(this.locationId, this.dayId, this.shiftId);
          });
        } catch (err) {
          alert(err);
        }
      },



      async attachProcdureShift() {
        try {
          if (!$('#addProcActForm').valid())
            return false;
          var request = {
            locationId: this.locationId, day: this.dayId, procId: this.selectedId,
            shiftId: this.shiftId
          };
          var response = await this.$http.post(
            '/api/Procedures/v1/AddProcActvity',
            request
          ).then(async response => {
            this.loadShiftProcedures(this.locationId, this.dayId, this.shiftId);
          });
        } catch (err) {
          alert(err);
        }
      },
    },
    computed: {
      allowSort() {
        return this.dataIsSortedBySelf;
      },

    },
    watch: {
    },
    mounted() {
      _componentValidation('#addProcActForm');
    }
  };


</script>

<style scoped>
  .select_container {
    width: calc(100%)
  }

  .card-title {
    font-size: 14px;
  }
</style>




// WEBPACK FOOTER //
// src/components/shift/manage-shift-procedures.vue